export const SourceProperty = {
  MESSAGES: 'messages',
  WORKBOOK_VIEW_ON_DEMAND: 'workbookViewOnDemand',
  CURRENT_LAODING_TASK_ID: 'currentLoadingTaskId'
} as const;
